import React, { FC, useRef } from "react"
import Footer from "@components/Footer"
import { GatsbyImage } from "gatsby-plugin-image"
import { graphql, useStaticQuery } from "gatsby"
import NavBar from "@components/NavBar"
import { Helmet } from "react-helmet"
import useIframeWrapper from "@hooks/useIframeWrapper"
import type { MainLayoutProps } from "./types"
import { Main } from "./styles"

const MainLayout: FC<MainLayoutProps> = ({
    children
}) => {
    const data = useStaticQuery<GatsbyTypes.strapiSettingQueryQuery>(graphql`
        query strapiSettingQuery {
            strapiSetting {
                footer {
                    title
                    subtitle
                    button {
                        label
                        link
                        color
                        outlined
                    }
                    image {
                        alternativeText
                        file {
                            childImageSharp {
                                gatsbyImageData(
                                    width: 774
                                    height: 824
                                    layout: CONSTRAINED
                                )
                            }
                        }
                    }
                    logo {
                        alternativeText
                        file {
                            childImageSharp {
                                gatsbyImageData(
                                    quality: 90
                                    width: 235
                                    layout: CONSTRAINED
                                )
                            }
                        }
                    }
                    links {
                        title
                        page {
                            id
                            slug
                            parent_page {
                                slug
                            }
                        }
                        direct_url
                    }
                }
                menu {
                    links {
                        title
                        page {
                            id
                            slug
                            parent_page {
                                slug
                            }
                        }
                        direct_url
                        submenu_links {
                            title
                            page {
                                id
                                slug
                                parent_page {
                                    slug
                                }
                            }
                            direct_url
                        }
                    }
                    button {
                        label
                        link
                        color
                        outlined
                    }
                    logo {
                        alternativeText
                        file {
                            childImageSharp {
                                gatsbyImageData(
                                    quality: 90
                                    width: 300
                                    layout: CONSTRAINED
                                    placeholder: NONE
                                )
                            }
                        }
                    }
                }
            }
        }
    `)

    const ref = useRef<HTMLElement>()
    useIframeWrapper(ref)

    const { strapiSetting } = data

    return <Main ref={ref}>
        <Helmet>
            <script async src="https://platform.twitter.com/widgets.js" charSet="utf-8" />
            <script
                async
                defer
                crossOrigin="anonymous"
                src="https://connect.facebook.net/nl_NL/sdk.js#xfbml=1&version=v13.0"
                nonce="RjpXhjFo"
            />
        </Helmet>
        <NavBar
            logo={<GatsbyImage
                image={strapiSetting.menu.logo.file.childImageSharp.gatsbyImageData}
                alt={`${strapiSetting.menu.logo?.alternativeText}`}
            />}
            links={strapiSetting.menu.links}
            button={strapiSetting.menu.button}
        />
        {children}
        <Footer
            subtitle={strapiSetting.footer.subtitle}
            title={strapiSetting.footer.title}
            button={strapiSetting.footer.button}
            image={<GatsbyImage
                image={strapiSetting.footer.image.file.childImageSharp.gatsbyImageData}
                alt={`${strapiSetting.footer.image?.alternativeText}`}
            />}
            links={strapiSetting.footer.links}
            logo={<GatsbyImage
                image={strapiSetting.footer.logo.file.childImageSharp.gatsbyImageData}
                alt={`${strapiSetting.footer.logo?.alternativeText}`}
            />}
        />
    </Main>
}

export default MainLayout
